// Sous-région Afrique de l'Ouest et Centrale (francophone) — liste éditable.
// Utilisée comme dropdown « Pays » dans les UI de l'admin (Écoles, Opportunités,
// Ingestion). Ordre : Afrique de l'Ouest puis Afrique Centrale.
export const SUB_REGION_COUNTRIES = [
  'Bénin',
  'Togo',
  "Côte d'Ivoire",
  'Sénégal',
  'Mali',
  'Burkina Faso',
  'Niger',
  'Guinée',
  'Cameroun',
  'Gabon',
  'Congo',
  'RD Congo',
  'Tchad',
]

export const countryOptions = SUB_REGION_COUNTRIES.map(name => ({ value: name, label: name }))

export const DEFAULT_COUNTRY = 'Bénin'
